import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Frequently asked questions banner',
    },
  },
};


export function FaqHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="faqhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Frequently asked questions banner"
    >
      <InnerPageHeroSubtitle path="faqhero.subtitle" />
      <RichTextContent
        path="faqhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="faqhero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="faqhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FaqHero',
  displayName: 'FAQ Hero',
  tokens: {
    'faqhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Frequently Asked Questions</p>',
    },
    'faqhero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Leasing Questions in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
    },
  },
  slotGroups: {
    'faqhero.bg_image': bgImageDef,
  },
};

(FaqHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default FaqHero;
